import styled from '@emotion/styled';

import Image from 'components/Image';

export const NameAndDate = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
`;

export const AuthorBox = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  margin-right: 2rem;
`;

export const AuthorImage = styled(Image)`
  border-radius: 50%;
`;

export const AuthorName = styled.div`
  margin-left: 10px;
`;
